import { Navigate } from 'react-router-dom';

const ExitController = ({ context }: any) => {
  return <Navigate state={context} to={context.navigationSource} />;
};

export default ExitController;
